/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as PrintRouteImport } from './routes/_print'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppOrgRouteImport } from './routes/_app/_org'
import { Route as AppPlatformRouteImport } from './routes/_app/platform'
import { Route as AppSourceHealthRouteImport } from './routes/_app/source-health'
import { Route as AppWatchesRouteImport } from './routes/_app/watches'
import { Route as AppOrgDashboardRouteImport } from './routes/_app/_org/dashboard'
import { Route as AppOrgMoreRouteImport } from './routes/_app/_org/more'
import { Route as AppOrgSettingsRouteImport } from './routes/_app/_org/settings'
import { Route as AppMarketIndexRouteImport } from './routes/_app/market/index'
import { Route as AppMarketListingIdRouteImport } from './routes/_app/market/$listingId'
import { Route as AppPlatformIndexRouteImport } from './routes/_app/platform/index'
import { Route as AppPlatformMoreRouteImport } from './routes/_app/platform/more'
import { Route as AppPlatformOverviewRouteImport } from './routes/_app/platform/overview'
import { Route as AppPlatformSettingsRouteImport } from './routes/_app/platform/settings'
import { Route as AppPlatformSourceHealthRouteImport } from './routes/_app/platform/source-health'
import { Route as AppPlatformWatchesRouteImport } from './routes/_app/platform/watches'
import { Route as AppOrgCustomersIndexRouteImport } from './routes/_app/_org/customers/index'
import { Route as AppOrgCustomersCustomerIdRouteImport } from './routes/_app/_org/customers/$customerId'
import { Route as AppOrgEvaluationsIndexRouteImport } from './routes/_app/_org/evaluations/index'
import { Route as AppOrgEvaluationsEvaluationIdRouteImport } from './routes/_app/_org/evaluations/$evaluationId'
import { Route as AppOrgSettingsIndexRouteImport } from './routes/_app/_org/settings/index'
import { Route as AppOrgSettingsMembersRouteImport } from './routes/_app/_org/settings/members'
import { Route as AppOrgSettingsNotificationsRouteImport } from './routes/_app/_org/settings/notifications'
import { Route as AppOrgSettingsOrganisationRouteImport } from './routes/_app/_org/settings/organisation'
import { Route as AppOrgSettingsValuationRulesRouteImport } from './routes/_app/_org/settings/valuation-rules'
import { Route as AppMarketSpecsSpecKeyRouteImport } from './routes/_app/market/specs.$specKey'
import { Route as AppPlatformMarketIndexRouteImport } from './routes/_app/platform/market/index'
import { Route as AppPlatformMarketListingIdRouteImport } from './routes/_app/platform/market/$listingId'
import { Route as AppPlatformMarketAnalysisRouteImport } from './routes/_app/platform/market/analysis'
import { Route as AppPlatformOrganisationsIndexRouteImport } from './routes/_app/platform/organisations/index'
import { Route as AppPlatformOrganisationsOrgIdRouteImport } from './routes/_app/platform/organisations/$orgId'
import { Route as PrintEvaluationsEvaluationIdSummaryRouteImport } from './routes/_print/evaluations/$evaluationId/summary'
import { Route as AppPlatformMarketSpecsSpecKeyRouteImport } from './routes/_app/platform/market/specs.$specKey'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const PrintRoute = PrintRouteImport.update({
  id: '/_print',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppOrgRoute = AppOrgRouteImport.update({
  id: '/_org',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformRoute = AppPlatformRouteImport.update({
  id: '/platform',
  path: '/platform',
  getParentRoute: () => AppRoute,
} as any)
const AppSourceHealthRoute = AppSourceHealthRouteImport.update({
  id: '/source-health',
  path: '/source-health',
  getParentRoute: () => AppRoute,
} as any)
const AppWatchesRoute = AppWatchesRouteImport.update({
  id: '/watches',
  path: '/watches',
  getParentRoute: () => AppRoute,
} as any)
const AppOrgDashboardRoute = AppOrgDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppOrgRoute,
} as any)
const AppOrgMoreRoute = AppOrgMoreRouteImport.update({
  id: '/more',
  path: '/more',
  getParentRoute: () => AppOrgRoute,
} as any)
const AppOrgSettingsRoute = AppOrgSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppOrgRoute,
} as any)
const AppMarketIndexRoute = AppMarketIndexRouteImport.update({
  id: '/market/',
  path: '/market/',
  getParentRoute: () => AppRoute,
} as any)
const AppMarketListingIdRoute = AppMarketListingIdRouteImport.update({
  id: '/market/$listingId',
  path: '/market/$listingId',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformIndexRoute = AppPlatformIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPlatformRoute,
} as any)
const AppPlatformMoreRoute = AppPlatformMoreRouteImport.update({
  id: '/more',
  path: '/more',
  getParentRoute: () => AppPlatformRoute,
} as any)
const AppPlatformOverviewRoute = AppPlatformOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AppPlatformRoute,
} as any)
const AppPlatformSettingsRoute = AppPlatformSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppPlatformRoute,
} as any)
const AppPlatformSourceHealthRoute = AppPlatformSourceHealthRouteImport.update({
  id: '/source-health',
  path: '/source-health',
  getParentRoute: () => AppPlatformRoute,
} as any)
const AppPlatformWatchesRoute = AppPlatformWatchesRouteImport.update({
  id: '/watches',
  path: '/watches',
  getParentRoute: () => AppPlatformRoute,
} as any)
const AppOrgCustomersIndexRoute = AppOrgCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AppOrgRoute,
} as any)
const AppOrgCustomersCustomerIdRoute =
  AppOrgCustomersCustomerIdRouteImport.update({
    id: '/customers/$customerId',
    path: '/customers/$customerId',
    getParentRoute: () => AppOrgRoute,
  } as any)
const AppOrgEvaluationsIndexRoute = AppOrgEvaluationsIndexRouteImport.update({
  id: '/evaluations/',
  path: '/evaluations/',
  getParentRoute: () => AppOrgRoute,
} as any)
const AppOrgEvaluationsEvaluationIdRoute =
  AppOrgEvaluationsEvaluationIdRouteImport.update({
    id: '/evaluations/$evaluationId',
    path: '/evaluations/$evaluationId',
    getParentRoute: () => AppOrgRoute,
  } as any)
const AppOrgSettingsIndexRoute = AppOrgSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOrgSettingsRoute,
} as any)
const AppOrgSettingsMembersRoute = AppOrgSettingsMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppOrgSettingsRoute,
} as any)
const AppOrgSettingsNotificationsRoute =
  AppOrgSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppOrgSettingsRoute,
  } as any)
const AppOrgSettingsOrganisationRoute =
  AppOrgSettingsOrganisationRouteImport.update({
    id: '/organisation',
    path: '/organisation',
    getParentRoute: () => AppOrgSettingsRoute,
  } as any)
const AppOrgSettingsValuationRulesRoute =
  AppOrgSettingsValuationRulesRouteImport.update({
    id: '/valuation-rules',
    path: '/valuation-rules',
    getParentRoute: () => AppOrgSettingsRoute,
  } as any)
const AppMarketSpecsSpecKeyRoute = AppMarketSpecsSpecKeyRouteImport.update({
  id: '/market/specs/$specKey',
  path: '/market/specs/$specKey',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformMarketIndexRoute = AppPlatformMarketIndexRouteImport.update({
  id: '/market/',
  path: '/market/',
  getParentRoute: () => AppPlatformRoute,
} as any)
const AppPlatformMarketListingIdRoute =
  AppPlatformMarketListingIdRouteImport.update({
    id: '/market/$listingId',
    path: '/market/$listingId',
    getParentRoute: () => AppPlatformRoute,
  } as any)
const AppPlatformMarketAnalysisRoute =
  AppPlatformMarketAnalysisRouteImport.update({
    id: '/market/analysis',
    path: '/market/analysis',
    getParentRoute: () => AppPlatformRoute,
  } as any)
const AppPlatformOrganisationsIndexRoute =
  AppPlatformOrganisationsIndexRouteImport.update({
    id: '/organisations/',
    path: '/organisations/',
    getParentRoute: () => AppPlatformRoute,
  } as any)
const AppPlatformOrganisationsOrgIdRoute =
  AppPlatformOrganisationsOrgIdRouteImport.update({
    id: '/organisations/$orgId',
    path: '/organisations/$orgId',
    getParentRoute: () => AppPlatformRoute,
  } as any)
const PrintEvaluationsEvaluationIdSummaryRoute =
  PrintEvaluationsEvaluationIdSummaryRouteImport.update({
    id: '/evaluations/$evaluationId/summary',
    path: '/evaluations/$evaluationId/summary',
    getParentRoute: () => PrintRoute,
  } as any)
const AppPlatformMarketSpecsSpecKeyRoute =
  AppPlatformMarketSpecsSpecKeyRouteImport.update({
    id: '/market/specs/$specKey',
    path: '/market/specs/$specKey',
    getParentRoute: () => AppPlatformRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/platform': typeof AppPlatformRouteWithChildren
  '/source-health': typeof AppSourceHealthRoute
  '/watches': typeof AppWatchesRoute
  '/dashboard': typeof AppOrgDashboardRoute
  '/more': typeof AppOrgMoreRoute
  '/settings': typeof AppOrgSettingsRouteWithChildren
  '/market/$listingId': typeof AppMarketListingIdRoute
  '/platform/more': typeof AppPlatformMoreRoute
  '/platform/overview': typeof AppPlatformOverviewRoute
  '/platform/settings': typeof AppPlatformSettingsRoute
  '/platform/source-health': typeof AppPlatformSourceHealthRoute
  '/platform/watches': typeof AppPlatformWatchesRoute
  '/market/': typeof AppMarketIndexRoute
  '/platform/': typeof AppPlatformIndexRoute
  '/customers/$customerId': typeof AppOrgCustomersCustomerIdRoute
  '/evaluations/$evaluationId': typeof AppOrgEvaluationsEvaluationIdRoute
  '/settings/members': typeof AppOrgSettingsMembersRoute
  '/settings/notifications': typeof AppOrgSettingsNotificationsRoute
  '/settings/organisation': typeof AppOrgSettingsOrganisationRoute
  '/settings/valuation-rules': typeof AppOrgSettingsValuationRulesRoute
  '/market/specs/$specKey': typeof AppMarketSpecsSpecKeyRoute
  '/platform/market/$listingId': typeof AppPlatformMarketListingIdRoute
  '/platform/market/analysis': typeof AppPlatformMarketAnalysisRoute
  '/platform/organisations/$orgId': typeof AppPlatformOrganisationsOrgIdRoute
  '/evaluations/$evaluationId/summary': typeof PrintEvaluationsEvaluationIdSummaryRoute
  '/customers/': typeof AppOrgCustomersIndexRoute
  '/evaluations/': typeof AppOrgEvaluationsIndexRoute
  '/settings/': typeof AppOrgSettingsIndexRoute
  '/platform/market/': typeof AppPlatformMarketIndexRoute
  '/platform/organisations/': typeof AppPlatformOrganisationsIndexRoute
  '/platform/market/specs/$specKey': typeof AppPlatformMarketSpecsSpecKeyRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/source-health': typeof AppSourceHealthRoute
  '/watches': typeof AppWatchesRoute
  '/dashboard': typeof AppOrgDashboardRoute
  '/more': typeof AppOrgMoreRoute
  '/market/$listingId': typeof AppMarketListingIdRoute
  '/platform/more': typeof AppPlatformMoreRoute
  '/platform/overview': typeof AppPlatformOverviewRoute
  '/platform/settings': typeof AppPlatformSettingsRoute
  '/platform/source-health': typeof AppPlatformSourceHealthRoute
  '/platform/watches': typeof AppPlatformWatchesRoute
  '/market': typeof AppMarketIndexRoute
  '/platform': typeof AppPlatformIndexRoute
  '/customers/$customerId': typeof AppOrgCustomersCustomerIdRoute
  '/evaluations/$evaluationId': typeof AppOrgEvaluationsEvaluationIdRoute
  '/settings/members': typeof AppOrgSettingsMembersRoute
  '/settings/notifications': typeof AppOrgSettingsNotificationsRoute
  '/settings/organisation': typeof AppOrgSettingsOrganisationRoute
  '/settings/valuation-rules': typeof AppOrgSettingsValuationRulesRoute
  '/market/specs/$specKey': typeof AppMarketSpecsSpecKeyRoute
  '/platform/market/$listingId': typeof AppPlatformMarketListingIdRoute
  '/platform/market/analysis': typeof AppPlatformMarketAnalysisRoute
  '/platform/organisations/$orgId': typeof AppPlatformOrganisationsOrgIdRoute
  '/evaluations/$evaluationId/summary': typeof PrintEvaluationsEvaluationIdSummaryRoute
  '/customers': typeof AppOrgCustomersIndexRoute
  '/evaluations': typeof AppOrgEvaluationsIndexRoute
  '/settings': typeof AppOrgSettingsIndexRoute
  '/platform/market': typeof AppPlatformMarketIndexRoute
  '/platform/organisations': typeof AppPlatformOrganisationsIndexRoute
  '/platform/market/specs/$specKey': typeof AppPlatformMarketSpecsSpecKeyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_print': typeof PrintRouteWithChildren
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/_app/_org': typeof AppOrgRouteWithChildren
  '/_app/platform': typeof AppPlatformRouteWithChildren
  '/_app/source-health': typeof AppSourceHealthRoute
  '/_app/watches': typeof AppWatchesRoute
  '/_app/': typeof AppIndexRoute
  '/_app/_org/dashboard': typeof AppOrgDashboardRoute
  '/_app/_org/more': typeof AppOrgMoreRoute
  '/_app/_org/settings': typeof AppOrgSettingsRouteWithChildren
  '/_app/market/$listingId': typeof AppMarketListingIdRoute
  '/_app/platform/more': typeof AppPlatformMoreRoute
  '/_app/platform/overview': typeof AppPlatformOverviewRoute
  '/_app/platform/settings': typeof AppPlatformSettingsRoute
  '/_app/platform/source-health': typeof AppPlatformSourceHealthRoute
  '/_app/platform/watches': typeof AppPlatformWatchesRoute
  '/_app/market/': typeof AppMarketIndexRoute
  '/_app/platform/': typeof AppPlatformIndexRoute
  '/_app/_org/customers/$customerId': typeof AppOrgCustomersCustomerIdRoute
  '/_app/_org/evaluations/$evaluationId': typeof AppOrgEvaluationsEvaluationIdRoute
  '/_app/_org/settings/members': typeof AppOrgSettingsMembersRoute
  '/_app/_org/settings/notifications': typeof AppOrgSettingsNotificationsRoute
  '/_app/_org/settings/organisation': typeof AppOrgSettingsOrganisationRoute
  '/_app/_org/settings/valuation-rules': typeof AppOrgSettingsValuationRulesRoute
  '/_app/market/specs/$specKey': typeof AppMarketSpecsSpecKeyRoute
  '/_app/platform/market/$listingId': typeof AppPlatformMarketListingIdRoute
  '/_app/platform/market/analysis': typeof AppPlatformMarketAnalysisRoute
  '/_app/platform/organisations/$orgId': typeof AppPlatformOrganisationsOrgIdRoute
  '/_print/evaluations/$evaluationId/summary': typeof PrintEvaluationsEvaluationIdSummaryRoute
  '/_app/_org/customers/': typeof AppOrgCustomersIndexRoute
  '/_app/_org/evaluations/': typeof AppOrgEvaluationsIndexRoute
  '/_app/_org/settings/': typeof AppOrgSettingsIndexRoute
  '/_app/platform/market/': typeof AppPlatformMarketIndexRoute
  '/_app/platform/organisations/': typeof AppPlatformOrganisationsIndexRoute
  '/_app/platform/market/specs/$specKey': typeof AppPlatformMarketSpecsSpecKeyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/invite'
    | '/login'
    | '/platform'
    | '/source-health'
    | '/watches'
    | '/dashboard'
    | '/more'
    | '/settings'
    | '/market/$listingId'
    | '/platform/more'
    | '/platform/overview'
    | '/platform/settings'
    | '/platform/source-health'
    | '/platform/watches'
    | '/market/'
    | '/platform/'
    | '/customers/$customerId'
    | '/evaluations/$evaluationId'
    | '/settings/members'
    | '/settings/notifications'
    | '/settings/organisation'
    | '/settings/valuation-rules'
    | '/market/specs/$specKey'
    | '/platform/market/$listingId'
    | '/platform/market/analysis'
    | '/platform/organisations/$orgId'
    | '/evaluations/$evaluationId/summary'
    | '/customers/'
    | '/evaluations/'
    | '/settings/'
    | '/platform/market/'
    | '/platform/organisations/'
    | '/platform/market/specs/$specKey'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/invite'
    | '/login'
    | '/source-health'
    | '/watches'
    | '/dashboard'
    | '/more'
    | '/market/$listingId'
    | '/platform/more'
    | '/platform/overview'
    | '/platform/settings'
    | '/platform/source-health'
    | '/platform/watches'
    | '/market'
    | '/platform'
    | '/customers/$customerId'
    | '/evaluations/$evaluationId'
    | '/settings/members'
    | '/settings/notifications'
    | '/settings/organisation'
    | '/settings/valuation-rules'
    | '/market/specs/$specKey'
    | '/platform/market/$listingId'
    | '/platform/market/analysis'
    | '/platform/organisations/$orgId'
    | '/evaluations/$evaluationId/summary'
    | '/customers'
    | '/evaluations'
    | '/settings'
    | '/platform/market'
    | '/platform/organisations'
    | '/platform/market/specs/$specKey'
  id:
    | '__root__'
    | '/_app'
    | '/_print'
    | '/invite'
    | '/login'
    | '/_app/_org'
    | '/_app/platform'
    | '/_app/source-health'
    | '/_app/watches'
    | '/_app/'
    | '/_app/_org/dashboard'
    | '/_app/_org/more'
    | '/_app/_org/settings'
    | '/_app/market/$listingId'
    | '/_app/platform/more'
    | '/_app/platform/overview'
    | '/_app/platform/settings'
    | '/_app/platform/source-health'
    | '/_app/platform/watches'
    | '/_app/market/'
    | '/_app/platform/'
    | '/_app/_org/customers/$customerId'
    | '/_app/_org/evaluations/$evaluationId'
    | '/_app/_org/settings/members'
    | '/_app/_org/settings/notifications'
    | '/_app/_org/settings/organisation'
    | '/_app/_org/settings/valuation-rules'
    | '/_app/market/specs/$specKey'
    | '/_app/platform/market/$listingId'
    | '/_app/platform/market/analysis'
    | '/_app/platform/organisations/$orgId'
    | '/_print/evaluations/$evaluationId/summary'
    | '/_app/_org/customers/'
    | '/_app/_org/evaluations/'
    | '/_app/_org/settings/'
    | '/_app/platform/market/'
    | '/_app/platform/organisations/'
    | '/_app/platform/market/specs/$specKey'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  PrintRoute: typeof PrintRouteWithChildren
  InviteRoute: typeof InviteRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_print': {
      id: '/_print'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PrintRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_org': {
      id: '/_app/_org'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppOrgRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform': {
      id: '/_app/platform'
      path: '/platform'
      fullPath: '/platform'
      preLoaderRoute: typeof AppPlatformRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/source-health': {
      id: '/_app/source-health'
      path: '/source-health'
      fullPath: '/source-health'
      preLoaderRoute: typeof AppSourceHealthRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/watches': {
      id: '/_app/watches'
      path: '/watches'
      fullPath: '/watches'
      preLoaderRoute: typeof AppWatchesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_org/dashboard': {
      id: '/_app/_org/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppOrgDashboardRouteImport
      parentRoute: typeof AppOrgRoute
    }
    '/_app/_org/more': {
      id: '/_app/_org/more'
      path: '/more'
      fullPath: '/more'
      preLoaderRoute: typeof AppOrgMoreRouteImport
      parentRoute: typeof AppOrgRoute
    }
    '/_app/_org/settings': {
      id: '/_app/_org/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppOrgSettingsRouteImport
      parentRoute: typeof AppOrgRoute
    }
    '/_app/market/': {
      id: '/_app/market/'
      path: '/market'
      fullPath: '/market/'
      preLoaderRoute: typeof AppMarketIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/market/$listingId': {
      id: '/_app/market/$listingId'
      path: '/market/$listingId'
      fullPath: '/market/$listingId'
      preLoaderRoute: typeof AppMarketListingIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/': {
      id: '/_app/platform/'
      path: '/'
      fullPath: '/platform/'
      preLoaderRoute: typeof AppPlatformIndexRouteImport
      parentRoute: typeof AppPlatformRoute
    }
    '/_app/platform/more': {
      id: '/_app/platform/more'
      path: '/more'
      fullPath: '/platform/more'
      preLoaderRoute: typeof AppPlatformMoreRouteImport
      parentRoute: typeof AppPlatformRoute
    }
    '/_app/platform/overview': {
      id: '/_app/platform/overview'
      path: '/overview'
      fullPath: '/platform/overview'
      preLoaderRoute: typeof AppPlatformOverviewRouteImport
      parentRoute: typeof AppPlatformRoute
    }
    '/_app/platform/settings': {
      id: '/_app/platform/settings'
      path: '/settings'
      fullPath: '/platform/settings'
      preLoaderRoute: typeof AppPlatformSettingsRouteImport
      parentRoute: typeof AppPlatformRoute
    }
    '/_app/platform/source-health': {
      id: '/_app/platform/source-health'
      path: '/source-health'
      fullPath: '/platform/source-health'
      preLoaderRoute: typeof AppPlatformSourceHealthRouteImport
      parentRoute: typeof AppPlatformRoute
    }
    '/_app/platform/watches': {
      id: '/_app/platform/watches'
      path: '/watches'
      fullPath: '/platform/watches'
      preLoaderRoute: typeof AppPlatformWatchesRouteImport
      parentRoute: typeof AppPlatformRoute
    }
    '/_app/_org/customers/': {
      id: '/_app/_org/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AppOrgCustomersIndexRouteImport
      parentRoute: typeof AppOrgRoute
    }
    '/_app/_org/customers/$customerId': {
      id: '/_app/_org/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AppOrgCustomersCustomerIdRouteImport
      parentRoute: typeof AppOrgRoute
    }
    '/_app/_org/evaluations/': {
      id: '/_app/_org/evaluations/'
      path: '/evaluations'
      fullPath: '/evaluations/'
      preLoaderRoute: typeof AppOrgEvaluationsIndexRouteImport
      parentRoute: typeof AppOrgRoute
    }
    '/_app/_org/evaluations/$evaluationId': {
      id: '/_app/_org/evaluations/$evaluationId'
      path: '/evaluations/$evaluationId'
      fullPath: '/evaluations/$evaluationId'
      preLoaderRoute: typeof AppOrgEvaluationsEvaluationIdRouteImport
      parentRoute: typeof AppOrgRoute
    }
    '/_app/_org/settings/': {
      id: '/_app/_org/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppOrgSettingsIndexRouteImport
      parentRoute: typeof AppOrgSettingsRoute
    }
    '/_app/_org/settings/members': {
      id: '/_app/_org/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AppOrgSettingsMembersRouteImport
      parentRoute: typeof AppOrgSettingsRoute
    }
    '/_app/_org/settings/notifications': {
      id: '/_app/_org/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AppOrgSettingsNotificationsRouteImport
      parentRoute: typeof AppOrgSettingsRoute
    }
    '/_app/_org/settings/organisation': {
      id: '/_app/_org/settings/organisation'
      path: '/organisation'
      fullPath: '/settings/organisation'
      preLoaderRoute: typeof AppOrgSettingsOrganisationRouteImport
      parentRoute: typeof AppOrgSettingsRoute
    }
    '/_app/_org/settings/valuation-rules': {
      id: '/_app/_org/settings/valuation-rules'
      path: '/valuation-rules'
      fullPath: '/settings/valuation-rules'
      preLoaderRoute: typeof AppOrgSettingsValuationRulesRouteImport
      parentRoute: typeof AppOrgSettingsRoute
    }
    '/_app/market/specs/$specKey': {
      id: '/_app/market/specs/$specKey'
      path: '/market/specs/$specKey'
      fullPath: '/market/specs/$specKey'
      preLoaderRoute: typeof AppMarketSpecsSpecKeyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/market/': {
      id: '/_app/platform/market/'
      path: '/market'
      fullPath: '/platform/market/'
      preLoaderRoute: typeof AppPlatformMarketIndexRouteImport
      parentRoute: typeof AppPlatformRoute
    }
    '/_app/platform/market/$listingId': {
      id: '/_app/platform/market/$listingId'
      path: '/market/$listingId'
      fullPath: '/platform/market/$listingId'
      preLoaderRoute: typeof AppPlatformMarketListingIdRouteImport
      parentRoute: typeof AppPlatformRoute
    }
    '/_app/platform/market/analysis': {
      id: '/_app/platform/market/analysis'
      path: '/market/analysis'
      fullPath: '/platform/market/analysis'
      preLoaderRoute: typeof AppPlatformMarketAnalysisRouteImport
      parentRoute: typeof AppPlatformRoute
    }
    '/_app/platform/organisations/': {
      id: '/_app/platform/organisations/'
      path: '/organisations'
      fullPath: '/platform/organisations/'
      preLoaderRoute: typeof AppPlatformOrganisationsIndexRouteImport
      parentRoute: typeof AppPlatformRoute
    }
    '/_app/platform/organisations/$orgId': {
      id: '/_app/platform/organisations/$orgId'
      path: '/organisations/$orgId'
      fullPath: '/platform/organisations/$orgId'
      preLoaderRoute: typeof AppPlatformOrganisationsOrgIdRouteImport
      parentRoute: typeof AppPlatformRoute
    }
    '/_print/evaluations/$evaluationId/summary': {
      id: '/_print/evaluations/$evaluationId/summary'
      path: '/evaluations/$evaluationId/summary'
      fullPath: '/evaluations/$evaluationId/summary'
      preLoaderRoute: typeof PrintEvaluationsEvaluationIdSummaryRouteImport
      parentRoute: typeof PrintRoute
    }
    '/_app/platform/market/specs/$specKey': {
      id: '/_app/platform/market/specs/$specKey'
      path: '/market/specs/$specKey'
      fullPath: '/platform/market/specs/$specKey'
      preLoaderRoute: typeof AppPlatformMarketSpecsSpecKeyRouteImport
      parentRoute: typeof AppPlatformRoute
    }
  }
}

interface AppOrgSettingsRouteChildren {
  AppOrgSettingsMembersRoute: typeof AppOrgSettingsMembersRoute
  AppOrgSettingsNotificationsRoute: typeof AppOrgSettingsNotificationsRoute
  AppOrgSettingsOrganisationRoute: typeof AppOrgSettingsOrganisationRoute
  AppOrgSettingsValuationRulesRoute: typeof AppOrgSettingsValuationRulesRoute
  AppOrgSettingsIndexRoute: typeof AppOrgSettingsIndexRoute
}

const AppOrgSettingsRouteChildren: AppOrgSettingsRouteChildren = {
  AppOrgSettingsMembersRoute: AppOrgSettingsMembersRoute,
  AppOrgSettingsNotificationsRoute: AppOrgSettingsNotificationsRoute,
  AppOrgSettingsOrganisationRoute: AppOrgSettingsOrganisationRoute,
  AppOrgSettingsValuationRulesRoute: AppOrgSettingsValuationRulesRoute,
  AppOrgSettingsIndexRoute: AppOrgSettingsIndexRoute,
}

const AppOrgSettingsRouteWithChildren = AppOrgSettingsRoute._addFileChildren(
  AppOrgSettingsRouteChildren,
)

interface AppOrgRouteChildren {
  AppOrgDashboardRoute: typeof AppOrgDashboardRoute
  AppOrgMoreRoute: typeof AppOrgMoreRoute
  AppOrgSettingsRoute: typeof AppOrgSettingsRouteWithChildren
  AppOrgCustomersCustomerIdRoute: typeof AppOrgCustomersCustomerIdRoute
  AppOrgEvaluationsEvaluationIdRoute: typeof AppOrgEvaluationsEvaluationIdRoute
  AppOrgCustomersIndexRoute: typeof AppOrgCustomersIndexRoute
  AppOrgEvaluationsIndexRoute: typeof AppOrgEvaluationsIndexRoute
}

const AppOrgRouteChildren: AppOrgRouteChildren = {
  AppOrgDashboardRoute: AppOrgDashboardRoute,
  AppOrgMoreRoute: AppOrgMoreRoute,
  AppOrgSettingsRoute: AppOrgSettingsRouteWithChildren,
  AppOrgCustomersCustomerIdRoute: AppOrgCustomersCustomerIdRoute,
  AppOrgEvaluationsEvaluationIdRoute: AppOrgEvaluationsEvaluationIdRoute,
  AppOrgCustomersIndexRoute: AppOrgCustomersIndexRoute,
  AppOrgEvaluationsIndexRoute: AppOrgEvaluationsIndexRoute,
}

const AppOrgRouteWithChildren =
  AppOrgRoute._addFileChildren(AppOrgRouteChildren)

interface AppPlatformRouteChildren {
  AppPlatformMoreRoute: typeof AppPlatformMoreRoute
  AppPlatformOverviewRoute: typeof AppPlatformOverviewRoute
  AppPlatformSettingsRoute: typeof AppPlatformSettingsRoute
  AppPlatformSourceHealthRoute: typeof AppPlatformSourceHealthRoute
  AppPlatformWatchesRoute: typeof AppPlatformWatchesRoute
  AppPlatformIndexRoute: typeof AppPlatformIndexRoute
  AppPlatformMarketListingIdRoute: typeof AppPlatformMarketListingIdRoute
  AppPlatformMarketAnalysisRoute: typeof AppPlatformMarketAnalysisRoute
  AppPlatformOrganisationsOrgIdRoute: typeof AppPlatformOrganisationsOrgIdRoute
  AppPlatformMarketIndexRoute: typeof AppPlatformMarketIndexRoute
  AppPlatformOrganisationsIndexRoute: typeof AppPlatformOrganisationsIndexRoute
  AppPlatformMarketSpecsSpecKeyRoute: typeof AppPlatformMarketSpecsSpecKeyRoute
}

const AppPlatformRouteChildren: AppPlatformRouteChildren = {
  AppPlatformMoreRoute: AppPlatformMoreRoute,
  AppPlatformOverviewRoute: AppPlatformOverviewRoute,
  AppPlatformSettingsRoute: AppPlatformSettingsRoute,
  AppPlatformSourceHealthRoute: AppPlatformSourceHealthRoute,
  AppPlatformWatchesRoute: AppPlatformWatchesRoute,
  AppPlatformIndexRoute: AppPlatformIndexRoute,
  AppPlatformMarketListingIdRoute: AppPlatformMarketListingIdRoute,
  AppPlatformMarketAnalysisRoute: AppPlatformMarketAnalysisRoute,
  AppPlatformOrganisationsOrgIdRoute: AppPlatformOrganisationsOrgIdRoute,
  AppPlatformMarketIndexRoute: AppPlatformMarketIndexRoute,
  AppPlatformOrganisationsIndexRoute: AppPlatformOrganisationsIndexRoute,
  AppPlatformMarketSpecsSpecKeyRoute: AppPlatformMarketSpecsSpecKeyRoute,
}

const AppPlatformRouteWithChildren = AppPlatformRoute._addFileChildren(
  AppPlatformRouteChildren,
)

interface AppRouteChildren {
  AppOrgRoute: typeof AppOrgRouteWithChildren
  AppPlatformRoute: typeof AppPlatformRouteWithChildren
  AppSourceHealthRoute: typeof AppSourceHealthRoute
  AppWatchesRoute: typeof AppWatchesRoute
  AppIndexRoute: typeof AppIndexRoute
  AppMarketListingIdRoute: typeof AppMarketListingIdRoute
  AppMarketIndexRoute: typeof AppMarketIndexRoute
  AppMarketSpecsSpecKeyRoute: typeof AppMarketSpecsSpecKeyRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppOrgRoute: AppOrgRouteWithChildren,
  AppPlatformRoute: AppPlatformRouteWithChildren,
  AppSourceHealthRoute: AppSourceHealthRoute,
  AppWatchesRoute: AppWatchesRoute,
  AppIndexRoute: AppIndexRoute,
  AppMarketListingIdRoute: AppMarketListingIdRoute,
  AppMarketIndexRoute: AppMarketIndexRoute,
  AppMarketSpecsSpecKeyRoute: AppMarketSpecsSpecKeyRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface PrintRouteChildren {
  PrintEvaluationsEvaluationIdSummaryRoute: typeof PrintEvaluationsEvaluationIdSummaryRoute
}

const PrintRouteChildren: PrintRouteChildren = {
  PrintEvaluationsEvaluationIdSummaryRoute:
    PrintEvaluationsEvaluationIdSummaryRoute,
}

const PrintRouteWithChildren = PrintRoute._addFileChildren(PrintRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  PrintRoute: PrintRouteWithChildren,
  InviteRoute: InviteRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
